var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConvert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1716",
    d: "M0-682.665H21v21H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40963",
    "data-name": "Group 40963",
    transform: "translate(-143 -423)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15547",
    "data-name": "Rectangle 15547",
    width: 24,
    height: 24,
    transform: "translate(143 423)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "left-and-right-arrows",
    transform: "translate(144.5 424.498)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1710",
    transform: "translate(0 0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1712"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1714",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1720",
    transform: "translate(13.576 10.008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1722",
    d: "M0,0,4.922,4.922,0,9.844",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1724",
    transform: "translate(0.82 14.93)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1726",
    d: "M-533.726,0h-16.939",
    transform: "translate(550.665)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1728",
    transform: "translate(2.543 1.148)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1730",
    d: "M-155.078,0-160,4.922l4.922,4.922",
    transform: "translate(160)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1732",
    transform: "translate(3.281 6.07)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1734",
    d: "M0,0H16.9",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvert);
export default __webpack_public_path__ + "static/media/convert.a41314c2eacfb55568184e98e309dbed.svg";
export { ForwardRef as ReactComponent };